<div class="aside_title-section">
  <h1 class="title-dashboard">{{ 'NEWS.NEWS' | translate }}</h1>
</div>

@if (permissionService.checkPermissionValue({ permission: 'READ', tab: 'administration' })) {
  <div class="widget-content-height">
    @if ($allNewsArray().length > 0) {
      @for (item of $allNewsArray() | slice: 0 : 5; track item) {
        <div routerLink="/resources/params" routerLinkActive="active">
          <div class="news-card">
            <div class="list-icon">
              @if ($showingNews() === $news()[item].uid_news) {
                <div class="badge"></div>
              }

              @switch ($news()[item].level) {
                @case (0) {
                  <mat-icon>
                    {{ $showingNews() === $news()[item].uid_news ? 'bookmark' : 'bookmark_border' }}
                  </mat-icon>
                }
                @case (1) {
                  <mat-icon>
                    {{ $showingNews() === $news()[item].uid_news ? 'add_circle' : 'add_circle_outline' }}
                  </mat-icon>
                }
                @case (2) {
                  <mat-icon>
                    {{ $showingNews() === $news()[item].uid_news ? 'error' : 'error_outline' }}
                  </mat-icon>
                }
              }
            </div>
            <div>
              <p [class]="$showingNews() === $news()[item].uid_news ? 'news-title bold' : 'news-title'">
                {{ $news()[item].title }}
              </p>
              <p class="news-subtitle">
                {{ $news()[item].display_time * 1000 | dynamicDate: 'shortDate' }}
              </p>
            </div>
          </div>
        </div>
      }
    } @else {
      <div class="missing-data-dashboard">
        <p>{{ 'NEWS.NO_NEWS' | translate }}</p>
      </div>
    }
  </div>
  @if ($allNewsArray().length > 5) {
    <div class="data-more-icon">
      <mat-icon
        routerLink="/resources/news"
        routerLinkActive="active"
        [matTooltip]="'COMMON.SEEMORE' | translate">
        more_horiz
      </mat-icon>
    </div>
  }
} @else {
  <p class="not-allowed-text">
    {{ 'USER.NOT_ACCESS_DATA' | translate }}
    <br />
    {{ 'USER.PLEASECONTACTADMIN' | translate }}
  </p>
}
